<ng-snotify></ng-snotify>

<!-- <app-login *ngIf="!isAuthed"></app-login> -->

<div>
  <router-outlet></router-outlet>
</div>